<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead">CONTENTS</h1>
<p class="line"></p>
<h2 class="toc_top"><a href="#/xhtml/07_Introduction"><span class="sfont">INTRODUCTION</span></a><br/><img alt="Image" src="images/common.jpg"/></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter_1" title="Link target outside of Sample"><span class="small">PART X</span> Face-to-Face with the Soviet Steamroller</span><br/><img alt="Image" src="images/common.jpg"/></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter_2" title="Link target outside of Sample"><span class="small">PART XI</span> The Mediterranean Front</span><br/><img alt="Image" src="images/common.jpg"/></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter_3" title="Link target outside of Sample"><span class="small">PART XII</span> The West: From One Landing to the Next</span><br/><img alt="Image" src="images/common.jpg"/></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter_4" title="Link target outside of Sample"><span class="small">PART XIII</span> Second Line and Training Units</span><br/><img alt="Image" src="images/common.jpg"/></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter_5" title="Link target outside of Sample"><span class="small">PART XIV</span> The Eagle Falls</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?581eee3f